import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getInteractions = () => {
  const dtMoodSession = getDtMoodSession()
  const userId = dtMoodSession ? dtMoodSession.userId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`gamifications/detail/${userId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sumInteraction = (username, interactions) => {
  const data = {
    interactions: Number(interactions)
  }

  return new Promise((resolve, reject) => {
    apiDtMood
      .put(`/api/users/${username}/interactions/`, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getInteractions, sumInteraction }
